// Respiratory subsection form field enum
export enum RespiratoryFormField {
  RESPIRATORY_STATUS = 'medical-background/respiratory/respiratory-status',
  RESPIRATORY_COUGH = 'medical-background/respiratory/cough',
  RESPIRATORY_OXYGEN = 'medical-background/respiratory/oxygen',
  RESPIRATORY_LUNG_SOUNDS = 'medical-background/respiratory/lung-sounds',
  RESPIRATORY_SYSTEM_SUMMARY = 'medical-background/respiratory/system-summary'
}
